import { httpsCallable } from 'firebase/functions';
import { functions } from '../config';

export const handleDeleteUserFromAuth = async (uid: string): Promise<void> => {
  const deleteUserFromAuth = httpsCallable(functions, 'deleteUserFromAuth');
  const result = (await deleteUserFromAuth({ uid })) as { data: { error?: string } };
  if (result.data?.error) {
    throw new Error(result.data.error);
  }
};
